import { inject, Injectable } from '@angular/core';

import { HeaderData, IHeaderData } from '../models/header-data';
import { HeaderStorageService } from '../../storage/services/storage-services/header-storage-service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable({
    providedIn: 'root',
})
export class HeaderService
{
    private readonly _headerStorageService = injectRequired(HeaderStorageService);

    headerData$$ = this._headerStorageService.headerData$$;

    headerData_set(headerData: Partial<IHeaderData>, reset = false) {
        if (reset) {
            const __headerData = HeaderData.create(headerData);
            if (__headerData) this.headerData$$.set(__headerData);
        } else {
            this.headerData$$.update(currData => ({...currData, ...headerData}));
        }
    }

    sideBlockLeft_show(value: boolean): void {
            this._headerStorageService.headerData$$.update(currData => ({...currData, sideBlockLeft_hide: value}));
    }
}

